export default "__VITE_ASSET__BaYQzHmp__"